export default "__VITE_ASSET__53f88069__"